<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { NameFormModal } from '../name-form-modal';

// Owns only rename's strings and emit name; the form behaviour lives in NameFormModal, shared with
// NewFolderModal and CopyModal (see that component for why the three were merged).
//
// `initialName` is the item's base name — a file's extension is fixed and never offered for editing —
// and is selected on open so replacing the whole name takes one keystroke.

const { t } = useI18n();

defineProps<{
  initialName: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'rename', newName: string): void;
}>();
</script>

<template>
  <NameFormModal
    :title="t('fileManager.renameModal.title')"
    :label="t('fileManager.renameModal.nameLabel')"
    :placeholder="t('fileManager.renameModal.namePlaceholder')"
    :submit-label="t('fileManager.renameModal.submitButton')"
    :cancel-label="t('fileManager.renameModal.cancel')"
    :close-aria-label="t('fileManager.renameModal.closeAriaLabel')"
    :initial-value="initialName"
    @submit="(name: string) => emit('rename', name)"
    @close="emit('close')"
  />
</template>
